export default __webpack_public_path__ + "static/media/fuelInActiveIcon.813d0ed7.svg";